import { render } from "./CourseLayout.vue?vue&type=template&id=410bdc2a&scoped=true"
import script from "./CourseLayout.vue?vue&type=script&lang=js"
export * from "./CourseLayout.vue?vue&type=script&lang=js"

import "./CourseLayout.vue?vue&type=style&index=0&id=410bdc2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410bdc2a"]])

export default __exports__